import api from '../services/api'
import { RESET } from '../redux/game'

// Actions
const FETCHING_OPEX_START = 'ascension/opex/fetching'
const FETCHING_OPEX_SUCCESS = 'ascension/opex/success'
const FETCHING_OPEX_ERROR = 'ascension/opex/error'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  opex: null
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_OPEX_START: {
      return {
        ...state,
        isLoading: true,
        opex: null,
        error: null
      }
    }
    case FETCHING_OPEX_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        opex: action.data
      }
    }
    case FETCHING_OPEX_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingOpexStart () {
  return {
    type: FETCHING_OPEX_START
  }
}

export function fetchingOpexSuccess (opex) {
  return {
    type: FETCHING_OPEX_SUCCESS,
    data: opex
  }
}

export function fetchingOpexError (error) {
  return {
    type: FETCHING_OPEX_ERROR,
    data: error
  }
}

// Action Creators

export function fetchOpex (team, round) {
  return async (dispatch) => {
    dispatch(fetchingOpexStart())

    try {
      const response = await api.getOpex(team, round)
      dispatch(fetchingOpexSuccess(response))
    } catch (e) {
      dispatch(fetchingOpexError(e))
    }
  }
}

export function fetchOpexBackground (team, round) {
  return async (dispatch) => {
    try {
      const response = await api.getOpex(team, round)
      dispatch(fetchingOpexSuccess(response))
    } catch (e) {

    }
  }
}

export function updateDecisions ({ team, round, decisions, deviceId }) {
  return async (dispatch) => {
    try {
      await api.updateOpexDecisions(team, round, decisions, deviceId)
    } catch (e) {
    }
  }
}
